import { render, staticRenderFns } from "./SetNames.vue?vue&type=template&id=2a13ec76&scoped=true&"
import script from "./SetNames.vue?vue&type=script&lang=js&"
export * from "./SetNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13ec76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a13ec76')) {
      api.createRecord('2a13ec76', component.options)
    } else {
      api.reload('2a13ec76', component.options)
    }
    module.hot.accept("./SetNames.vue?vue&type=template&id=2a13ec76&scoped=true&", function () {
      api.rerender('2a13ec76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LocationService/SetNames.vue"
export default component.exports